<template>
  <div>
    <UTooltip :text="badge.tooltip ? badge.tooltip : badge.text">
      <div
        :class="badge?.classes"
        class="cursor-pointer"
      >
        <Icon v-if="badge.icon" :name="badge.icon" class="flex-shrink-0 h-4 w-4 pt-0 mr-1" />
        <svg
          v-if="badge.iconSvgD"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
          class="flex-shrink-0 h-4 w-4 pt-0 mr-1"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            :d="badge.iconSvgD"
          />
        </svg>
        {{ badge.text ? badge.text : "Example" }}
      </div>
    </UTooltip>
  </div>
</template>

<script setup lang="ts">
interface Badge {
  classes: string[];
  id?: string;
  icon?: string;
  iconSvgD?: string;
  text: string;
  tooltip: string;
}

const props = defineProps<{
  badge: Badge;
}>()

const { badge } = toRefs(props)
</script>
